import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { XYLEM } from 'src/constants/type';
import { selectPlayerParams } from 'src/lib/redux';
import { isOTT } from 'src/lib/utilities';

export function usePlayerParamsEffects() {
  const playerParams = useSelector(selectPlayerParams);

  useEffect(() => {
    // if (playerParams.token && playerParams.randomId) {
    //   localStorage.setItem(LocalStorageKeys.TOKEN_CAPS, playerParams.token);
    //   localStorage.setItem(LocalStorageKeys.RANDOMID, playerParams.randomId);
    // } else {
    //   // Update dev token from cred.json
    //   updateDevTokenFromCred();
    // }
    if (playerParams.cameFrom === XYLEM) {
      document.body.classList.add('xylem');
    }

    if (isOTT()) {
      document.body.classList.add('ott');
    } else {
      document.body.classList.remove('ott');
    }
  }, [playerParams]);
}
